import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Contract} from "../../../../classes/contract";
import {kanContractsService} from "../../../services/services/contracts";
import {kanTermsService} from "../../../services/services/terms";
import {Term} from "../../../../classes/term";

@Component({
    selector: 'kan-service-dialog',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanContractDialog {
    public contract: Contract = new Contract();
    public isNew: boolean = true;
    public terms: Term[] = [];
    public contractForm: FormGroup;

    constructor(private dialogRef: MatDialogRef<kanContractDialog>,
                private formBuilder: FormBuilder,
                private contractService: kanContractsService,
                private termsService: kanTermsService,
                @Inject(MAT_DIALOG_DATA) private data: any) {

        if (this.data && this.data.contract) {
            this.contract = JSON.parse(JSON.stringify(this.data.contract));
            this.isNew = false;
        }
    }

    ngOnInit(): void {
        this.contractForm = this.formBuilder.group({
            body: new FormControl(this.contract.body),
            terms: new FormControl(this.contract.terms)
        });

        this.termsService.getTerms()
            .then((terms) => {
                this.terms = terms;
            });
    }

    public add(event: any) {

        this.serialize();

        this.contractService.addContract(this.contract)
            .then((contract) => {
                this.dialogRef.close({action: 'add', contract: contract});
            })
            .catch((error) => {
                console.log(error);
            });
    }

    public update(event: any) {

        this.serialize();

        this.contractService.updateContract(this.contract)
            .then((contract) => {
                this.dialogRef.close({action: 'update', contract: contract});
            })
            .catch((error) => {
                console.log(error);
            });
    }

    private serialize() {
        this.contract.body = this.contract.body.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/dialogs/contract-dialog/component.ts